import React, { useState } from "react";
import OwnerPreFilters from "../../../../components/BuilderComponents/PreFilters/OwnerPreFilters";
import { NewPrefilter } from "../../../../components/BuilderComponents/PreFilters/PreFilter";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import CalendarFilter from "./CalendarFilter";

const EditCalendarFilter = ({ tableRef, currentSmLookup, tableType, tableId }) => {
  const { currentBlockConfig, setCurrentBlockConfig } = useAppBlocksContext();
  const { data } = currentBlockConfig;
  const [selectedFilterTab, setSelectedFilterTab] = useState("subject filter");

  const settingFilters = (type, data) => {
    const newCurrentBlockConfig = { ...currentBlockConfig };
    newCurrentBlockConfig.data[type] = data;
    setCurrentBlockConfig(newCurrentBlockConfig);
  };
  const handleOwnerPrefilter = (data) => {
    settingFilters("owner_pre_filters", data);
  };

  const handleChangeSinglePrefilter = (data) => {
    settingFilters("pre_filters", data.prefilter);
    settingFilters("prefilters_joined_by", data.prefilters_joined_by);
  };

  return (
    <>
      <div className="filter_sub_menu_container">
        {["subject filter", "pre filters"].map((name) => (
          <div
            key={name}
            className={`filter_sub_menu ${selectedFilterTab === name && "selected"}`}
            onClick={() => setSelectedFilterTab(name)}
          >
            {name}
          </div>
        ))}
      </div>
      <div style={{ width: "480px" }}>
        {selectedFilterTab === "subject filter" && (
          <CalendarFilter tableRef={tableRef} currentSmLookup={currentSmLookup} />
        )}
        {selectedFilterTab === "pre filters" && (
          <div className="p_3 flex_column gap_3">
            {(tableType === "statemachine" || tableType === "rdbms") && (
              <OwnerPreFilters
                ownerPreFilters={data.owner_pre_filters}
                setOwnerPreFilters={handleOwnerPrefilter}
                tableData={tableRef}
              />
            )}
            <NewPrefilter
              prefiltersWithFormula={{
                prefilter: data.pre_filters || [],
                prefilters_joined_by: data?.prefilters_joined_by || ""
              }}
              handleChange={handleChangeSinglePrefilter}
              tableId={tableId}
              folderIds={[]}
              tableType={tableType}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default EditCalendarFilter;
